/// <reference path="appbase.ts" />
/// <reference path="app_settings.ts" />
/// <reference path="app_pack_order.ts" />

namespace TerminalApp {
    //packaging cache
    let packagings: SP.PackagingInfo[];


    interface IOrderPackLineInfo {
        totes: SP.ToteInfo[];
        orderLineId: string;
        shipmentLineData: SP.ShipmentLineData[];
        itemInfo: SP.ItemInfo;
        quantity: number;
        max: number;
        updateAmount: (value: number, set: boolean) => void;

    }

    class SerialNumberModel {
        Id: string;
        itemInfo: SP.ItemInfo;
        ShipmentLineData: SP.ShipmentLineData;
    }
 
    export class App_Fast_Pack_Order extends AppBase {
        static Instance: App_Fast_Pack_Order;
        tote: SP.ToteInfo = null;
        shipment: SP.ShipmentInfo = null;
        customer: SP.CustomerInfo = null;
        editPackage: SP.PackageInfo = null;
        weight_controller = new WeightController();
        delivery_method_picker = new PickAssistant<SP.DeliveryMethod>(SP.Localize("sentance_select_delivery_method"));
        parcel_type_picker = new KeyValuePickAssistant(SP.Localize("sentance_select_parcel_type"));
        kvp_picker = new KeyValuePickAssistant("");
        packaging_picker = new PickAssistant<SP.PackagingInfo>(SP.Localize("sentance_select_packaging"));
        fpo_tote_info = document.getElementById("fpo_tote_info");
        fpo_tote_name = document.getElementById("fpo_tote_name");
        fpo_print_note_button = document.getElementById("fpo_print_note_button");
        fpo_serialnumber_button = document.getElementById("fpo_serialnumber_button");
        fpo_weight_icon = document.getElementById("fpo_weight_icon");
        fpo_order_info = document.getElementById("fpo_order_info");
        fpo_label_form = document.getElementById("fpo_label_form");
        fpo_finish = document.getElementById("fpo_finish");
        fpo_sorting = document.getElementById("fpo_sorting");
        fpo_sorting_list = document.getElementById("fpo_sorting_list");
        fpo_finish_order = document.getElementById("fpo_finish_order");
        fpo_cancel_countdown = document.getElementById("fpo_cancel_countdown");
        fpo_countdown = document.getElementById("fpo_countdown");
        fpo_warehousenotification_button = document.getElementById("fpo_warehousenotification_button");
        fpo_items = document.getElementById("fpo_items");
        fpo_labels = document.getElementById("fpo_labels");
        fpo_delivery_method = document.getElementById("fpo_delivery_method") as HTMLInputElement;
        fpo_packaging = document.getElementById("fpo_packaging") as HTMLInputElement;
        fpo_parcel_type = document.getElementById("fpo_parcel_type") as HTMLInputElement;
        fpo_reference = document.getElementById("fpo_reference") as HTMLInputElement;
        fpo_order = document.getElementById("fpo_order") as HTMLInputElement;
        fpo_delivery_instructions = document.getElementById("fpo_delivery_instructions") as HTMLInputElement;
        fpo_length = document.getElementById("fpo_length") as HTMLInputElement;
        fpo_height = document.getElementById("fpo_height") as HTMLInputElement;
        fpo_width = document.getElementById("fpo_width") as HTMLInputElement;
        fpo_weight = document.getElementById("fpo_weight") as HTMLInputElement;
        fpo_create_label = document.getElementById("fpo_create_label");
        fpo_order_cancel = document.getElementById("fpo_order_cancel");
        fpo_addons = document.getElementById("fpo_addons");
        fpo_reset_all = document.getElementById("fpo_reset_all");
        fpo_select_all = document.getElementById("fpo_select_all");
        fpo_reset_select_buttons = document.getElementById("fpo_reset_select_buttons");
        fpo_parameters = document.getElementById("fpo_parameters");
        selected_delivery_method: string = null;
        selected_parcel_type: string = "";
        selected_packaging: SP.PackagingInfo;
        autofill: boolean;
        height: number;
        width: number;
        length: number;
        weight: number;
        bound = false;
        allPacked: boolean;
        allSorted: boolean;


        timeleft: number;

        serialNumberForm: SerialNumberAssistant;

        serialNumberArray: SerialNumberModel[] = [];

        items: { [orderLineId: string]: IOrderPackLineInfo } = {};

        constructor() {
            super("app_fast_pack_order");

            this.serialNumberForm = new SerialNumberAssistant();
            this.container.appendChild(this.serialNumberForm.container);

            App_Fast_Pack_Order.Instance = this;
            this.fpo_warehousenotification_button.addEventListener("click", () => {
                this.fpo_warehousenotification_button.style.display = "block";
                new SP.DismissInfo("Warehouse Notification (OrderNo: " + this.shipment.order.orderNo + ")", this.shipment.order.warehouseNotificationPacker);
            });
            this.fpo_print_note_button.addEventListener("click", () => { this.printDeliveryNote(false); });

            this.fpo_serialnumber_button.addEventListener("click", () => {
                this.serialNumberForm.open(this.serialNumberArray, this.shipment.shipmentId, () => {
                    this.reloadView();
                });
            });

            this.fpo_weight_icon.style.pointerEvents = "all";
            this.fpo_weight_icon.addEventListener("click", () => {
                this.weight_controller.load(this.shipment, false, () => {
                    this.reloadView();
                });
            });
            this.container.appendChild(this.delivery_method_picker.container);
            this.container.appendChild(this.parcel_type_picker.container);
            this.container.appendChild(this.kvp_picker.container);
            this.container.appendChild(this.packaging_picker.container);

            this.fpo_delivery_method.addEventListener("focus", () => {
                this.delivery_method_picker.open(dm => { this.setDeliveryMethod(dm); SP.Sounds.Click.play(); });
                this.fpo_delivery_method.blur();
            });

            this.fpo_parcel_type.addEventListener("focus", () => {
                this.parcel_type_picker.open(pt => { this.setParcelType(pt.key, pt.value); SP.Sounds.Click.play(); });
                this.fpo_parcel_type.blur();
            });

            this.fpo_packaging.addEventListener("focus", () => {
                this.packaging_picker.open(pt => { this.setPackaging(pt); SP.Sounds.Click.play(); });
                this.fpo_packaging.blur();
            });

            this.container.querySelectorAll("input:not(.noselect)").forEach(elm => {
                elm.addEventListener("focus", () => { (elm as HTMLInputElement).select() });
            });

            this.fpo_weight.addEventListener("change", () => {
                this.weight = parseInt(this.fpo_weight.value);
                this.updateDeliveryMethods()
            });

            this.fpo_width.addEventListener("change", () => {
                this.width = parseInt(this.fpo_width.value);
                this.updateDeliveryMethods()
            });

            this.fpo_height.addEventListener("change", () => {
                this.height = parseInt(this.fpo_height.value);
                this.updateDeliveryMethods()
            });

            this.fpo_length.addEventListener("change", () => {
                this.length = parseInt(this.fpo_length.value);
                this.updateDeliveryMethods()
            });

            var printing = false; //prevent double click

            this.fpo_create_label.addEventListener("click", async () => {
                if (printing) return;
                printing = true;
                StartLoading();
                this.fpo_create_label.classList.add("btn_disabled");
                await this.printShippingLabel();
                SP.Sounds.Click.play();
                this.fpo_create_label.classList.remove("btn_disabled");
                StopLoading();
                printing = false;
            });

            this.fpo_cancel_countdown.addEventListener("click", () => {
                this.fpo_countdown.innerHTML = ``
                this.fpo_cancel_countdown.style.display = "none";
                this.timeleft = 1000;
                SP.Sounds.Click.play();
            });

            this.fpo_finish_order.addEventListener("click", async () => {
                StartLoading();
                this.fpo_finish_order.classList.add("btn_disabled");
                this.timeleft = 1000;
                await this.finishOrder();
                this.fpo_finish_order.classList.remove("btn_disabled");
                StopLoading();
            });

            this.fpo_order_cancel.addEventListener("click", async () => {
                if (!await SP.confirmX(SP.Localize("text_cancel_packing"))) return;
                StartLoading();
                this.timeleft = 1000;
                await this.cancelShipment();
                StopLoading();
            });

            this.fpo_reset_all.addEventListener("click", () => {
                for (var key in this.items) {
                    console.log(this.items[key]);
                    if (this.items[key]?.updateAmount)
                        this.items[key]?.updateAmount(0, true);
                }
                SP.Sounds.Click.play();

            });

            this.fpo_select_all.addEventListener("click", () => {
                for (var key in this.items) {
                    console.log(this.items[key]);
                    if (this.items[key]?.updateAmount)
                        this.items[key]?.updateAmount(this.items[key].max, true);
                }
                SP.Sounds.Click.play();

            });
        }

        async finishOrder() {
            let result = await SP.get<any>("/api/v1/shipment/finish/" + this.shipment.shipmentId);
            if (result.status == 200) {
                SP.Sounds.Success.play();
                SP.setAllHash({ "app": "app_pack_tote_list" });
            }
            else await SP.alertX(result.status + ": " + result.msg);
        }

        async cancelShipment() {
            StartLoading();
            let data = {
                shipmentId: this.shipment.shipmentId,
                force: true
            }

            let result = await SP.post<any>("/API/v1/PickList/moveShipment/", data);
            if (result.status == 200) {
                SP.Sounds.Success.play();
                SP.setAllHash({ "app": "app_pack_tote_list" });
            }
            else {
                SP.alertX("Error " + result.status + ": " + result.msg);
            }
            StopLoading();
        }

        async onOpen() {
            this.reset();

            if (packagings == null) {
                this.packaging_picker.addItem(null, true, SP.Localize("word_none"), "");
                packagings = await SP.Data.Packaging.getPackagingInfos();
                for (let i = 0; i < packagings.length; i++) {
                    let p = packagings[i];
                    this.packaging_picker.addItem(p, true, p.name, p.barcode);
                }
            }

            //bind events and groups
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on(null, this.scanBarcode, this);
                barcodeListener.on("t", this.scanTote, this);
                barcodeListener.on("print", this.scanPrinter, this);
                barcodeListener.on("pc", this.scanPallet, this);
                barcodeListener.on("sz", this.scanZone, this);
                document.addEventListener("keydown", this.inputListener);

            }

            var toteId = SP.getHash("tote");
            var bc = SP.getHash("barcode");
            if (toteId) this.loadTote(toteId, bc);

        }

        async onClose() {
            if (this.bound) {
                this.bound = false;
                barcodeListener.off(null, this.scanBarcode);
                barcodeListener.off("t", this.scanTote);
                barcodeListener.off("print", this.scanPrinter);
                barcodeListener.off("pc", this.scanPallet);
                barcodeListener.off("sz", this.scanZone);
                document.removeEventListener("keydown", this.inputListener);

                if (this.tote) {
                    await hub.connection.invoke<boolean>("releaseTote", this.tote.toteId);
                }
            }
            this.reset();
        }


        spaceTime: number;
        spacePrintTime: number;
        async inputListener(e: KeyboardEvent) {
            var _this = App_Fast_Pack_Order.Instance;
            if (e.which == 32) {

                if (document.activeElement instanceof HTMLInputElement)
                    return;

                var now = performance.now();
                var dif = now - _this.spaceTime;

                if (dif <= 1000) {

                    //prevent spam if space is kept down!
                    if (performance.now() - _this.spacePrintTime < 1000) {
                        _this.spacePrintTime = performance.now();

                        return;
                    }


                    _this.spaceTime = 0;
                    _this.spacePrintTime = performance.now();
                    _this.fpo_create_label.click();
                }
                _this.spaceTime = now;
            }
        }

        reset() {
            this.fpo_warehousenotification_button.style.display = "none";
            this.customer = null;
            this.tote = null;
            this.shipment = null;
            this.selected_delivery_method = null;
            this.selected_packaging = null;
            this.selected_parcel_type = null;
            this.timeleft = 1000;
            this.fpo_reset_all.style.display = "none";
            this.fpo_select_all.style.display = "none";

            this.serialNumberArray = [];
            this.fpo_serialnumber_button.classList.remove("serialNumber-btn-active");
        }

        async loadTote(id: string, barcodeScan: string = "") {
            this.reset();

            //check that tote is locked to us
            if (!(await hub.connection.invoke<boolean>("lockTote", parseInt(id)))) {
                if (!await SP.confirmX("tote is not locked to you! do you want to force open it?")) {
                    await TerminalApp.GetApp("app_pack_tote_list").open();
                    return;
                }
            }

            //get tote info
            var tote = this.tote = await SP.Data.Tote.getToteInfo(id, false);

            console.log("LoadTote", tote);

      

            if (!tote.readyForPack) return SP.alertX("tote not ready for packing!");

            this.fpo_tote_info.style.backgroundColor = tote.toteColor;
            this.fpo_tote_name.innerHTML = tote.toteName;
            this.autofill = !this.tote.groupPick && !barcodeScan.length;

            await this.reloadView();

            //check that tote is locked to us
            if (tote.blockPacker) {
                SP.alertX("Shipment for (OrderNo: " + this.shipment.order.orderNo + ", RefNo: " + this.shipment.order.referenceNo + ") is BLOCKED! remove 'BlockPacker' to bypass this!");
                await TerminalApp.GetApp("app_pack_tote_list").open();
                //    if (!await SP.confirmX("Shipment is BLOCKED! do you want to force open it?")) {
                //        return;
                //    }
            }

            if (barcodeScan.length) await this.scanBarcode(barcodeScan);
            if (this.shipment.order.warehouseNotificationPacker) this.fpo_warehousenotification_button.click();
            if (this.shipment.order.deliveryMethodInfo.warehouseNotificationPacker) new SP.DismissInfo("Delivery Method Notification", this.shipment.order.deliveryMethodInfo.warehouseNotificationPacker);

            this.fpo_reset_select_buttons.style.display = tote.pickSettings.forceItemBarcodeScanning ? "none" : "block";


            this.fpo_items.querySelectorAll(".info").forEach((e) => { (e as HTMLElement).click(); });


            //this.fpo_order_info.innerHTML = `<b>${this.customer.customerName}</b><br />
            //                                   <b><a target="_blank" href="/admin/customers/orders/form?id=${this.shipment.order.customerId}&orderid=${this.shipment.order.orderId}">${this.shipment.order.orderNo}</a></b> ${this.shipment.order.recipient.name}<br />
            //                                    ${this.shipment.order.deliveryMethodInfo.name}`

            this.fpo_order_info.innerHTML = `<b>${this.customer.customerName}</b><br />
                                               <b><a href="/terminal/#app=app_order_info&orderId=${this.shipment.order.orderId}">${this.shipment.order.orderNo}</a></b> ${this.shipment.order.recipient.name}<br />
                                                ${this.shipment.order.deliveryMethodInfo.name}`

               


       /*     if (App_Settings.userSettings.print_delivery_instantly && (this.shipment.order.printDeliveryNote || (this.tote.pickSettings?.forceDeliveryNote ?? false) || (this.selectedDeliveryMethod?.forceDeliveryNote ?? false))) this.printDeliveryNote(false);*/

           

            if (this.needSerialNumber) {
                this.serialNumberForm.open(this.serialNumberArray, this.shipment.shipmentId, () => {
                    this.reloadView();
                });
            }
            else {
                var manual_click = SP.getHash("clicked") == "true";
                if (!manual_click) this.autoPrintLabel();
            }
        }

        needSerialNumber: boolean;

        async reloadView() {
            this.timeleft = 1000;
            this.shipment = await SP.Data.Shipment.getShipmentInfo(this.tote.shipmentId);
            this.customer = await SP.Data.Customer.getCustomerInfo(this.shipment.order.customerId);
            this.autofill = App_Settings.userSettings.allow_autofill_package && this.autofill && (this.tote.pickSettings?.autofillPackageFromTote ?? true);

            this.prepareItems(this.autofill);
            this.renderItems();
            this.renderLabels();
            this.setPackageInfo();
            this.updateMetrics();


            if (!this.tote.pickSettings.scanPackageCollection && (this.selectedDeliveryMethod && !this.selectedDeliveryMethod.forceScanPackageCollection)) this.allSorted = true;

            this.waitingSorting = this.allPacked && !this.allSorted;
            this.fpo_label_form.style.display = this.allPacked ? "none" : "block";
            this.fpo_finish.style.display = (this.allPacked && this.allSorted) ? "block" : "none";
            this.fpo_sorting.style.display = this.waitingSorting ? "block" : "none";
            if (this.allPacked && this.allSorted) this.startCountdown();
            if (this.waitingSorting) this.setSortingInfo();
            this.checkForSerialNumber();
        }

        waitingSorting = false;

        async setSortingInfo() {
            SP.Sounds.Notification.play();
            this.fpo_sorting_list.innerHTML = "";
            for (let i = 0; i < this.shipment.packages.length; i++) {
                let p = this.shipment.packages[i];
                if (!p.packageCollectionId) {
                    var zone: any = await SP.get(`/api/v1/sortingzone/find?packageId=${p.id}`);

                    let bc = document.createElement("div");
                    bc.innerHTML = `<div class="btn noselect" style="display: flex;"><span class="text big center">${zone.data.name}</span></div>`;
                    bc.addEventListener("click", async () => {
                        if (await SP.confirmX("force zone?")) {
                            this.scanZone(zone.data.id);
                        }
                    });
                    this.fpo_sorting_list.appendChild(bc);
                }
            }
        }

        scanPallet(pcId: string) {
            this.addToPackageCollection(pcId, null);
        }

        scanZone(szId: string) {
            this.addToPackageCollection(null, szId);
        }

        async addToPackageCollection(pcId:string, szId:string) {
            var success = false;

            for (let i = 0; i < this.shipment.packages.length; i++) {
                let p = this.shipment.packages[i];
                if (!p.packageCollectionId) {
                    let result = await SP.post<any>("/api/v1/packageCollection/addPackage", {
                        packageCollectionId: pcId ? parseInt(pcId) : null,
                        sortingZoneId: szId,
                        packageId: p.id
                    });
                    if (result.status == 200) {
                        success = true;
                    }
                }
            }

            if (!success) {
                SP.Sounds.Error.play();
            }
            else {
                SP.Sounds.Success.play();
                this.reloadView();
            }
        }


        checkForSerialNumber() {
            this.needSerialNumber = false;
            let hasSerialNumbers = false;
            this.serialNumberArray = [];

            for (var i = 0; i < this.shipment.lines.length; i++) {

                if (!this.shipment.lines[i].orderLine.itemInfo.registerSerialNumber) {
                    continue;
                }

                hasSerialNumbers = true;

                let serialNumberDataArray = [];

                for (var u = 0; u < this.shipment.lines[i].data.length; u++) {
                    if (this.shipment.lines[i].data[u].type == SP.ShipmentLineDataType.SerialNumber) {
                        serialNumberDataArray.push(this.shipment.lines[i].data[u]);
                    }
                }

                for (var u = 0; u < this.shipment.lines[i].qty; u++) {

                    var serialModel = new SerialNumberModel();
                    serialModel.Id = this.shipment.lines[i].id;
                    serialModel.itemInfo = this.shipment.lines[i].orderLine.itemInfo;
                    serialModel.ShipmentLineData = null;

                    if (serialNumberDataArray[u] != null) {
                        serialModel.ShipmentLineData = serialNumberDataArray[u];
                    }

                    if (serialModel.ShipmentLineData == null || serialNumberDataArray[u].value.length === 0) {
                        this.needSerialNumber = true;
                    }

                    this.serialNumberArray.push(serialModel);
                }
            }

            if (hasSerialNumbers) {
                this.fpo_serialnumber_button.classList.add("serialNumber-btn-active");
            }
        }

        async startCountdown() {
            this.fpo_cancel_countdown.style.display = "block";
            this.timeleft = App_Settings.userSettings.finish_package_delay;
            if (this.timeleft) {
            while (true) {
                if (this.timeleft >= 100) return;
                if (this.timeleft <= 0) break;
                this.fpo_countdown.innerHTML = `( ${this.timeleft} )`;
                this.timeleft--;
                await SP.sleep(1000);
                }
            }
            this.fpo_countdown.innerHTML = ``;
            this.fpo_cancel_countdown.style.display = "none";
            this.fpo_finish_order.click();
        }

        renderLabels() {
            this.fpo_labels.style.display = this.shipment.packages.length ? "block" : "none";
            this.fpo_labels.innerHTML = "";
            this.allSorted = true;

            for (let i = 0; i < this.shipment.packages.length; i++) {
                let label = this.shipment.packages[i];

     

                console.log("LABEL: ", label);
                if (!label.isColli && !label.trackingNumber) continue;

                let elm = this.fpo_labels.appendChild(document.createElement("div"));
                elm.className = "shipping_label";

                let itemCount = 0;
                for (let i = 0; i < label.lines.length; i++) {
                    itemCount += label.lines[i].quantity;
                }

                var colliText = "";
                if (label.isColli && !label.trackingNumber) colliText += SP.Localize("sentance_pending_colli") + " (" + itemCount + " " + SP.Localize("word_items") + ")";

                var messurementsText = (label.width * 0.1) + "x" + (label.height * 0.1) + "x" + (label.length  * 0.1) + "cm - " + (label.weight * 0.001) + "kg";

                elm.innerHTML = `
                    <span class="remove button label"><i class="fa-solid fa-trash"></i></span>
                    <span class="carrier_name">${label.deliveryMethodName}</span><br />
                    <span class="tracking_number">${label.trackingNumber} ${colliText} ${messurementsText}</span>
                    `;

                //reprint button
                if (!label.isColli || label.id == label.parentPackageId) {
                    elm.innerHTML += `
                    <span class="note button label"><i class="fa-solid fa-scroll"></i></span>
                    <span class="print button label"><i class="fa-solid fa-print"></i> ${SP.Localize("word_reprint")}</span>
                    `;

                    let print_label = elm.querySelector(".print");
                    let print_note = elm.querySelector(".note");

                    print_label.addEventListener("click", async () => {
                        if (!await SP.confirmX(SP.Localize("text_confirm_double_label_print"))) return;

                        if (!App_Settings.terminalSettings.label_printer)
                            return await SP.alertX(SP.Localize("sentance_please_select_printer"));

                        SP.Sounds.Click.play();
                        print_label.classList.add("btn_disabled");
                        var result = await SP.get<any>("/api/v1/package/print/" + label.id + "?label_printer=" + App_Settings.terminalSettings.label_printer + "&etiquette_printer=" + App_Settings.terminalSettings.etiquette_printer + "&a4_printer=" + App_Settings.terminalSettings.a4_printer);
                        if (result.status != 200) await SP.alertX(result.status + ": " + result.msg + (result.exception ? " - " + result.exception : ""));
                        print_label.classList.remove("btn_disabled");
                    });

                    print_note.addEventListener("click", async () => {
                        if (!App_Settings.terminalSettings.label_printer)
                            return await SP.alertX(SP.Localize("sentance_please_select_printer"));
                        SP.Sounds.Click.play();

                        print_note.classList.add("btn_disabled");
                        var result = await SP.get<any>("/api/v1/package/printnote/" + label.id + "?label_printer=" + App_Settings.terminalSettings.label_printer + "&etiquette_printer=" + App_Settings.terminalSettings.etiquette_printer + "&a4_printer=" + App_Settings.terminalSettings.a4_printer);
                        if (result.status != 200) await SP.alertX(result.status + ": " + result.msg + (result.exception ? " - " + result.exception : ""));
                        print_note.classList.remove("btn_disabled");
                    });
                };
                
                let remove = elm.querySelector(".remove");

                remove.addEventListener("click", async () => {
                    if (!await SP.confirmX(SP.Localize("text_confirm_delete_package"))) return;
                    SP.Sounds.Click.play();
                    var result: any = await SP.get("/api/v1/package/delete/" + label.id);
                    if (result.status != 200) await SP.alertX(result.msg);
                    else await this.reloadView();
                });

                if (label.packageCollectionId == null) {
                    this.allSorted = false;
                }
                else {
                    //set checkmark as scanned
                }

                
            }
        }

        prepareItems(autofill: boolean) {
            this.items = {};
            this.fpo_items.innerHTML = "";

            //sort by sku
            this.shipment.lines.sort((a, b) => a.orderLine.itemInfo.sku.localeCompare(b.orderLine.itemInfo.sku));

            for (let i in this.shipment.lines) {
                let sl = this.shipment.lines[i];

                let current = this.items[sl.orderLine.id];
                if (!current) {
                    current = this.items[sl.orderLine.id] = {
                        orderLineId: sl.orderLine.id,
                        itemInfo: sl.orderLine.itemInfo,
                        shipmentLineData: sl.data,
                        max: sl.qty,
                        quantity: 0,
                        updateAmount: null,
                        totes: []
                    };
                }
                else {
                    current.max += sl.qty;
                }
            }

            this.shipment.packages.forEach(p => p.lines.forEach(l => {
                if (!p.isColli && !p.trackingNumber) return; //dont count unpacked and finished
                let current = this.items[l.orderLineId];
                if (current) {
                    if (p != this.editPackage) current.max -= l.quantity;
                }
            }));

            if (autofill) {
                for (let i = 0; i < this.tote.picks.length; i++) {
                    let pick = this.tote.picks[i];
                    let item = this.items[pick.orderLineId];
                    item.quantity += pick.qty;
                    item.quantity = Math.min(item.quantity, item.max);
                }
            }

            if (this.tote.additionalShipmentTotes && this.tote.additionalShipmentTotes.length) {
                for (let t = 0; t < this.tote.additionalShipmentTotes.length; t++) {
                    let additionalTote = this.tote.additionalShipmentTotes[t];
                    additionalTote.picks
                    for (let i = 0; i < additionalTote.picks.length; i++) {
                        let pick = additionalTote.picks[i];
                        let item = this.items[pick.orderLineId];
                        item.totes.push(additionalTote);
                    }
                }
                for (let i = 0; i < this.tote.picks.length; i++) {
                    let pick = this.tote.picks[i];
                    let item = this.items[pick.orderLineId];
                    item.totes.push(this.tote);
                }
            }

        }

        renderItems() {
            this.allPacked = true;
            var forceScanBarcode = this.tote?.pickSettings?.forceItemBarcodeScanning ?? false;
            console.log("shipment", this.shipment);
            console.log("items", this.items);
            for (let orderLineId in this.items) {
                let item = this.items[orderLineId];

                if (item.max > 0) {
                    this.allPacked = false;
                    let elm = this.fpo_items.appendChild(document.createElement("div"));
                    elm.className = "order_item_new";

                    let model = (item.itemInfo.manufacturerName + " " + item.itemInfo.modelNo).trim();


                    elm.innerHTML = `
                        <span class="info button label" style="display:none" id="fpo_print_info_button"><i class="fa-solid fa-memo-circle-info"></i></span>
                        <div class="image"><img src="${item.itemInfo.imageUrl}"></div>
                        
                        <div class="sku ellipsis"><div class="totes"></div><b>${item.itemInfo.sku}</b>${model ? ' - ' + model : ''}</div>
                        <div class="name ellipsis">${item.itemInfo.description}</div>
                        <div class="barcodes ellipsis">${item.itemInfo.barcodes.join(', ')}</div>
                        <div class="serialNumbers ellipsis"></div>
                        <div class="buttons">
                            <div class="minus button label"><i class="fa-solid fa-minus"></i></div>
                            <div class="label amt" style="background-color: #a0ab93;"></div>
                            <div class="plus ${forceScanBarcode ? "disabled" : ""} button label"><i class="fa-solid fa-plus"></i></div>
                        </div> `;

                    if (item.shipmentLineData.length > 0 || item.itemInfo.registerSerialNumber) {
                        elm.querySelector(".serialNumbers").innerHTML += "SN: ";

                        for (var i = 0; i < item.shipmentLineData.length; i++) {
                            if (item.shipmentLineData[i].type === SP.ShipmentLineDataType.SerialNumber && item.shipmentLineData[i].value.length != 0) {
                                elm.querySelector(".serialNumbers").innerHTML += "<span>" + item.shipmentLineData[i].value + ", </span>";
                            }
                        }
                    }

                    let toteContainer = elm.querySelector(".totes");
                    for (var i = 0; i < item.totes.length; i++) {
                        let tote = item.totes[i];
                        let toteElm = document.createElement("span");
                        toteElm.classList.add("label");
                        toteElm.style.backgroundColor = tote.toteColor;
                        toteElm.innerHTML = tote.toteName;
                        toteContainer.appendChild(toteElm);
                    }


                    elm.querySelector(".image").addEventListener("click", (e) => {
                        itemShortcutAssistant.open_with_info(item.itemInfo);
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    //warehouse notification
                    if (item.itemInfo.warehouseNotificationPacker) {
                        let info_btn = elm.querySelector(".info") as HTMLElement;
                        info_btn.style.display = "";
                        info_btn.addEventListener("click", () => {
                            new SP.DismissInfo("Warehouse Notification (Item: " + item.itemInfo.sku + ")", item.itemInfo.warehouseNotificationPacker);
                        });
                    }

                    let amt = elm.querySelector(".amt") as HTMLElement;
                    item.updateAmount = (value: number, set: boolean) => {
                        let newA = this.items[item.orderLineId].quantity = Math.max(0, set ? value : this.items[item.orderLineId].quantity + value);
                        amt.innerHTML = `${newA} / ${item.max}`;
                        amt.style.backgroundColor = newA < item.max ? "#a0ab93" : newA > item.max ? "#d94646" : "";
                        this.updateMetrics();
                    }
                    item.updateAmount(item.quantity, true);


                    if (!forceScanBarcode) {
                        let count_container = elm.querySelector(".label.amt");
                        let amt_input: HTMLInputElement;
                        count_container.addEventListener("click", () => {
                            if (!amt_input) {
                                count_container.innerHTML = `<input type='number' class='amt_input' value='${item.quantity}' />`;
                                amt_input = count_container.querySelector(".amt_input");
                      
                                amt_input.addEventListener("blur", () => {
                                    var val = parseFloat(amt_input.value) ?? 0;
                                    amt_input = null;
                                    item.updateAmount(val, true);
                                });
                            }
                        
                            amt_input.focus();
                            amt_input.select();
                        });
                    }

                    //if (App_Settings.userSettings.allow_split_delivery) {
                    SP.bindClickHold(elm.querySelector(".plus") as HTMLElement, 500,
                        () => { item.updateAmount(1, false); SP.Sounds.Click.play(); }, //click
                        () => { item.updateAmount(item.max, true); SP.Sounds.Click.play(); } //hold
                    );

                    SP.bindClickHold(elm.querySelector(".minus") as HTMLElement, 500,
                        () => { item.updateAmount(-1, false); SP.Sounds.Click.play(); }, //click
                        () => { item.updateAmount(0, true); SP.Sounds.Click.play(); } //hold
                    );
                    //}
                    //else {
                    //    elm.querySelector(".plus").remove();
                    //    elm.querySelector(".minus").remove();
                    //}
                }
            }

            
        }

        updateDeliveryMethods() {
            this.delivery_method_picker.clear();
            var dimensions = [this.length, this.height, this.width].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            var length = dimensions[2];
            var circumferenceLength = dimensions[0] * 2 + dimensions[1] * 2 + dimensions[2];
            var weight = this.weight;

            var defaultId = this.editPackage?.deliveryMethodId ?? this.shipment.order.deliveryMethodInfo.id;
            var noneMethod: SP.DeliveryMethod = null;

            for (let key in this.customer.deliveryMethods) {
                let m = this.customer.deliveryMethods[key];

                if (m.orderSources.length && !m.orderSources.includes(this.shipment.order.orderSource)) continue;
                if (m.isReturn) continue;
                var error = "";

                let available = false;

                var destinationCountry = this.shipment.order.recipient.country.toUpperCase();
                var localPrices = m.prices[destinationCountry];

                if (localPrices) {
                    let remaining = localPrices.filter(l =>
                        (l.maxCircumferenceLength == 0 || l.maxCircumferenceLength >= circumferenceLength) &&
                        (l.maxLength == 0 || l.maxLength >= length) &&
                        (l.maxWeight == 0 || l.maxWeight >= weight)
                    );
                    if (remaining.length) available = true;
                    else error = SP.Localize("sentance_no_shipping_rate_found_for_weight_or_dimensions");
                }
                else {
                    error = SP.Localize("sentance_no_delivery_country_match");
                }

                (m as any).available = available;
                this.delivery_method_picker.addItem(m, available, m.name, error);

                if (m.name == "None") noneMethod = m;
                if (m.id == this.selected_delivery_method) this.setDeliveryMethod(m);
                if (this.selected_delivery_method == null && defaultId == m.id) this.setDeliveryMethod(m);
            }
            if (this.selected_delivery_method == null && noneMethod != null) this.setDeliveryMethod(noneMethod);


            if (this.selectedDeliveryMethod) {
                this.refreshColliBookingView();
            }
        }

        refreshColliBookingView() {
            var allPacked = true;
            for (var id in this.items) {
                var l = this.items[id];
                if (l.quantity < l.max) {
                    allPacked = false;
                    break;
                }
            }

            var colli = this.selectedDeliveryMethod.useColliBooking;
            var shipment = !this.selectedDeliveryMethod.useColliBooking || allPacked;

            container.querySelectorAll(".colli_exclusive").forEach(elm => { (elm as HTMLElement).style.display = colli ? "" : "none" });
            container.querySelectorAll(".shipment_exclusive").forEach(elm => { (elm as HTMLElement).style.display = shipment ? "" : "none" });
            container.querySelectorAll(".colli_shipment_exclusive").forEach(elm => { (elm as HTMLElement).style.display = shipment && colli ? "" : "none" });


            if (colli && !shipment) {
                container.querySelectorAll(".disable_for_colli_only").forEach(elm => {
                    (elm as HTMLElement).style.opacity = "0.4";
                    (elm as HTMLElement).style.pointerEvents = "none";
                });

                container.querySelectorAll(".hide_for_colli_only").forEach(elm => {
                    (elm as HTMLElement).style.display = "none";
                });
            }
            else {
                container.querySelectorAll(".disable_for_colli_only").forEach(elm => {
                    (elm as HTMLElement).style.opacity = "";
                    (elm as HTMLElement).style.pointerEvents = "";
                });

                container.querySelectorAll(".hide_for_colli_only").forEach(elm => {
                    (elm as HTMLElement).style.display = "";
                });
            }

            

            //this.refreshParameters();
            console.log("refreshing booking ", colli, shipment);
        }

        addons: SP.ShippingMethodAddon[] = [];
        parameters: SP.ShippingMethodParameter[] = [];
        _parametersUpdateFunctions: { (): void; }[] = [];

        refreshParameters() {
            for (let i = 0; i < this._parametersUpdateFunctions.length; i++) {
                this._parametersUpdateFunctions[i]();
            }
            console.log("refreshing?");


        }

        setAddons(m: SP.DeliveryMethod) {
            //clear addons
            this.addons = [];
            let hasAddons = m.addons && m.addons.length;
            this.fpo_addons.innerHTML = "";
                var show = false;

            if (hasAddons) {
                //copy to break reference
                var addons = SP.clone(m.addons);

                //set headline
                for (let i = 0; i < addons.length; i++) {
                    let addon = addons[i];
                    if (!addon.include) continue;

                    //add container
                    let cont = document.createElement("div");
                    cont.classList.add("addon");
                    this.fpo_addons.appendChild(cont);

                    if (addon.visible && addon.scope != "colli") cont.classList.add("hide_for_colli_only");

                    //checkbox
                    let cb = cont.appendChild(document.createElement("input"));
                    cb.name = "addon";
                    cb.value = addon.code;
                    cb.type = "checkbox";
                    let doodle = new SP.CheckboxDoodle(cb);
                    let children = document.createElement("div");

                    doodle.onChange = () => {
                        if (doodle.checked) {
                            if (this.addons.indexOf(addon) == -1) {
                                this.addons.push(addon);
                            }
                        }
                        else {
                            this.addons.splice(this.addons.indexOf(addon), 1);
                        }
                        text.style.color = doodle.checked ? "#fff" : "";
                        children.style.display = doodle.checked ? "block" : "none";
                        this.refreshParameters();
                    }


                    //set text
                    let text = cont.appendChild(document.createElement("span"));
                    text.innerHTML = addon.name;
                    cont.style.display = addon.visible ? "block" : "none";

                    //select if default enabled
                    if (addon.defaultEnabled) this.addons.push(addon);
                    doodle.checked = addon.defaultEnabled;
                    text.style.color = doodle.checked ? "#fff" : "";

                    //add container for child properties (if visible)
                    if (addon.visible) {
                        show = true;
                        children.classList.add("addon_" + addon.code)
                        children.style.display = doodle.checked ? "block" : "none";
                        this.fpo_addons.appendChild(children);
                    }
                }
            }

            this.fpo_addons.style.display = show ? "block" : "none";


        }

        setParameters(m: SP.DeliveryMethod) {
            //clear parameters
            this.parameters = [];
            this._parametersUpdateFunctions = [];

            let hasParameters = m.parameters && m.parameters.length;
            this.fpo_parameters.innerHTML = "";
            var show = false;

            if (hasParameters) {
                //copy to break reference
                var params = SP.clone(m.parameters);

                //set headline
                for (let i = 0; i < params.length; i++) {
                    let param = params[i];
                    if (!param.include) continue;

                    this.parameters.push(param);

                    let default_value = param.value;

                    //append container
                    let cont = document.createElement("div");
                    cont.classList.add("param", "type_" + param.type);
                    cont.style.display = param.visible ? "block" : "none";

                    if (param.visible && param.scope != "colli") cont.classList.add("hide_for_colli_only");
                    

                    //append to parrent (general or addon parameter)
                    let parent = this.fpo_addons.querySelector(".addon_" + param.addonDependency);
                    if (!parent) {
                        if (param.visible) show = true;
                        parent = this.fpo_parameters;
                    }
                    parent.appendChild(cont);

                    //set text
                    var text = cont.appendChild(document.createElement("span"));
                    text.classList.add("text");
                    if (param.scope) text.innerHTML += "<span class='label'>" + param.scope + "</span> ";
                    text.innerHTML += param.name;

                    //create inputs
                    let input = document.createElement("input");
                    input.placeholder = param.name;
                    cont.appendChild(input);
                    let doodle: SP.CheckboxDoodle;
                    let numberDoodle: SP.NumberDoodle;


                    //boolean/checkbox
                    if (param.type == SP.ShippingMethodParameterType.boolean) {
                        input.type = "checkbox";
                        input.name = "param";
                        doodle = new SP.CheckboxDoodle(input);
                        param.value = default_value;
                        doodle.checked = default_value == "true";

                        doodle.onChange = () => {
                            param.value = doodle.checked.toString();
                        }
                    }
                    else if (param.type == SP.ShippingMethodParameterType.integer) {
                        input.type = "number";
                        numberDoodle = new SP.NumberDoodle(input);
                        param.value = default_value;
                        numberDoodle.value = default_value;

                        numberDoodle.onChange = () => {
                            param.value = numberDoodle.value.toString();
                        }
                    }

                    //text / date / password / dictionary
                    else {

                        //add textinput class
                        cont.classList.add("messurement");

                        //set type
                        if (param.type == SP.ShippingMethodParameterType.datetime) {
                            input.type = "datetime-local";
                            input.placeholder = "dd-MM-yyyy HH:mm";
                        }
                        else if (param.type == SP.ShippingMethodParameterType.date) {
                            input.type = "date";
                            input.placeholder = "dd-MM-yyyy";
                        }
                        else if (param.type == SP.ShippingMethodParameterType.timeofday) {
                            input.type = "time";
                            input.placeholder = "HH:mm";
                        }
                        else if (param.type == SP.ShippingMethodParameterType.integer) input.type = "number";
                        else if (param.type == SP.ShippingMethodParameterType.password) input.type = "password";
                        else input.type = "text";

                        //set default value
                        if (default_value != null) {
                            if (param.type == SP.ShippingMethodParameterType.options) {
                                console.log("PARAM:", param);
                                var selected = param.options.find(p => p.key == default_value);
                                if (selected) input.value = selected.value;
                            }
                            else {
                                input.value = default_value;
                            }
                            param.value = default_value;
                        }
                        else {
                            input.value = "";
                            param.value = null;
                        }

                        //dictionary menu / picker
                        if (param.type == SP.ShippingMethodParameterType.options) {
                            input.addEventListener("focus", () => {

                                this.kvp_picker.setAllFromArray(param.options, param.name, SP.Localize("word_none"), "");
                                this.kvp_picker.open(result => {
                                    param.value = result.key;
                                    input.value = result.value;
                                });
                                this.fpo_parcel_type.blur();
                            });

                        }
                        else {
                            input.addEventListener("input", () => {
                                param.value = input.value;
                            });
                        }
                    }

                    //update function (show or not)
                    this._parametersUpdateFunctions.push(() => {
                        let show = true;
                        let visible = cont.style.display == "block";
                        if (param.addonDependency) {
                            if (!this.addons.find(x => x.code == param.addonDependency)) {
                                param.value = null;
                                show = false;
                            }
                        }
                        cont.style.display = show && param.visible ? "block" : "none";
                        if (!visible && show) {
                            if (default_value != null) {
                                if (param.type == SP.ShippingMethodParameterType.options) {
                                    var selected = param.options.find(p => p.key == default_value);
                                    if (selected) input.value = selected.value;
                                }
                                else input.value = default_value;
                                param.value = default_value;
                            }
                            if (doodle && param.value == "true") {
                                doodle.checked = true;
                                doodle.onChange();
                            }
                            else {
                                input.value = param.value;
                            }
                        }
                    });
                }
            }

            //refresh view

            this.refreshParameters();
     

            this.fpo_parameters.style.display = show ? "block" : "none";
        }

        selectedDeliveryMethod: SP.DeliveryMethod;
        setDeliveryMethod(m: SP.DeliveryMethod) {
            console.log("setDeliveryMethod", m);
            //set red background if not available
            let available = (m as any).available;
            this.fpo_delivery_method.style.backgroundColor = available ? '' : '#eb7575';


            if (this.selected_delivery_method != m.id) {
    

                //update selected method and input
                this.selected_delivery_method = m.id;
                this.fpo_delivery_method.value = m.name;



                //update parceltype and pick if selected is availabe
                var parcelTypeDictionary = {} as any;
                m.parcelTypes.forEach(pt => { if (pt.enabled) parcelTypeDictionary[pt.code] = pt.name; });

                this.parcel_type_picker.setAll(parcelTypeDictionary, SP.Localize("sentance_select_parcel_type"), null, null)
                let pt_picked = false;
                for (var key in parcelTypeDictionary) {
                    var name = parcelTypeDictionary[key];
                    if (name == this.selected_parcel_type) {
                        pt_picked = true;
                        this.setParcelType(key, name);
                    }
                }

                //update addons and parameters
                this.setAddons(m);
                this.setParameters(m);

                //Autopick parcel-type if only 1 option, or clear selection if many
                if (!pt_picked) {
                    if (Object.keys(parcelTypeDictionary).length == 1) {
                        this.setParcelType(Object.keys(parcelTypeDictionary)[0], parcelTypeDictionary[Object.keys(parcelTypeDictionary)[0]]);
                    }
                    else this.setParcelType(null, null);
                }


                this.selectedDeliveryMethod = m;
                this.updateMetrics();
            }
        }

        setParcelType(key: string, name: string) {
            this.selected_parcel_type = key;
            this.fpo_parcel_type.value = key != null ? name : SP.Localize("sentance_select_parcel_type");
            this.fpo_parcel_type.style.backgroundColor = key != null ? '' : '#eb7575';
        }

        setPackageInfo() {
            this.fpo_packaging.value = "None";
            this.fpo_reference.value = this.editPackage?.referenceNo ?? this.shipment.order.referenceNo;
            if (this.tote.pickSettings?.appendToteNameToReference ?? false) this.fpo_reference.value += " (" + this.tote.toteName + ")";


            this.fpo_order.value = this.editPackage?.orderNo ?? this.shipment.order.orderNo;
            if (this.tote.pickSettings?.appendToteNameToOrderNo ?? false) this.fpo_order.value += " (" + this.tote.toteName + ")";

            this.fpo_delivery_instructions.value = this.editPackage?.deliveryInstructions ?? this.shipment.order.deliveryInstructions;
            this.fpo_length.value = (this.editPackage?.length ?? 0).toString();
            this.fpo_height.value = (this.editPackage?.height ?? 0).toString();
            this.fpo_width.value = (this.editPackage?.width ?? 0).toString();
            this.fpo_weight.value = (this.editPackage?.weight ?? 0).toString();

        }

        lastPrintScan: number = 0;
        async scanTote(toteId: string) {
            if (this.waitingSorting) {
                SP.Sounds.Error.play();
                return;
            }

            clearTimeout(this.printTimeout);

            if (toteId == this.tote.toteId.toString()) {
                if (SP.ActiveNotifications.length) return SP.Sounds.Error.play();
                var now = performance.now();
                if (now - this.lastPrintScan < 500) {
                    return this.fpo_create_label.click();
                }
                this.lastPrintScan = now;
                return;
            }
            else {
                this.lastPrintScan = 0;
                if (this.timeleft < 100) {
                    Talk("word_wait");
                    return;
                }

                //get tote info
                var tote = await SP.Data.Tote.getToteInfo(toteId, false);

                //check if ready
                if (!tote.readyForPack) return SP.Sounds.Error.play();
                SP.setAllHash({ "app": "app_fast_pack_order", "tote": toteId });
            }
        }


        async scanPrinter(printerName: string) {
            if (SP.ActiveNotifications.length) return SP.Sounds.Error.play();

            var now = performance.now();
            if (App_Settings.userSettings.auto_double_scan_print_label || now - this.lastPrintScan < 500) {
                selectPrinter(printerName);
                return this.fpo_create_label.click();
            }
            this.lastPrintScan = now;
        }

        printTimeout: any;

        async scanBarcode(barcode: string) {
            if (this.waitingSorting) {
                SP.Sounds.Error.play();
                return;
            }

            clearTimeout(this.printTimeout);
            if (SP.ActiveNotifications.length) return SP.Sounds.Error.play();

            let current: IOrderPackLineInfo = null;
            var qty: number = null;

            //hard match
            for (let lineId in this.items) {
                let item = this.items[lineId];
                var m_qty = GetBarcodeQty(item.itemInfo.allBarcodes, barcode);
                if (m_qty !== null) {
                    current = item;
                    qty = m_qty;
                    if (current.quantity < current.max) break;
                }
            }

            if (current != null) {
                current.updateAmount(qty ? qty : 1, false);
                if (current.quantity > current.max) return await SP.Sounds.Error.play();
                else {
                    this.autoPrintLabel();
                    return SP.Sounds.Click.play();
                }
            }

            var packaging = packagings.filter(p => p.barcode.includes(barcode))[0];
            if (packaging != null) {
                SP.Sounds.Click.play();
                return this.setPackaging(packaging);
            }
            SP.Sounds.Error.play();
        }

        autoPrintLabel() {
            clearTimeout(this.printTimeout);
            let _this = this;
            this.printTimeout = setTimeout(() => {
                if (!App_Settings.userSettings.auto_print_shipping_label || !(this.tote.pickSettings?.autoPrintLabel ?? false)) return;
                if (SP.ActiveNotifications.length) return;
                for (let lineId in _this.items) {
                    let item = _this.items[lineId];
                    if (item.quantity != item.max) return;
                }
                _this.fpo_create_label.click();
            }, 500);
        }

        setPackaging(packaging: SP.PackagingInfo) {
            this.selected_packaging = packaging;
            this.fpo_packaging.value = packaging?.name ?? SP.Localize("word_none");
            this.updateMetrics();

            
        }

        updateMetrics() {
            this.length = 0;
            this.height = 0;
            this.width = 0;
            this.weight = 0;
            var selectedCount = 0;

            if (this.selected_packaging) {
                this.weight = this.selected_packaging.weight;
                this.height = this.selected_packaging.height;
                this.width = this.selected_packaging.width;
                this.length = this.selected_packaging.debth;
            }
            for (var id in this.items) {
                var item = this.items[id];

                if (item.max == 0 || item.quantity == 0) continue;

                selectedCount += item.quantity;

                this.weight += (item.itemInfo.warehouseWeight > 0 ? item.itemInfo.warehouseWeight : item.itemInfo.weight) * item.quantity;
                this.width = Math.max(this.width, item.itemInfo.width);
                this.height = Math.max(this.height, item.itemInfo.height);
                this.length = Math.max(this.length, item.itemInfo.debth);
            }

            this.fpo_length.value = this.length.toString();
            this.fpo_height.value = this.height.toString();
            this.fpo_width.value = this.width.toString();
            this.fpo_weight.value = this.weight.toString();
            this.updateDeliveryMethods();

            this.fpo_reset_all.style.display = selectedCount > 0 ? "block" : "none";
            this.fpo_select_all.style.display = selectedCount <= 0 ? "block" : "none";
        }

        async printShippingLabel() {
            //validate stuff
            //if (!printer)
            //    return await SP.alertX(SP.Localize("sentance_please_select_printer"));

            if (this.selected_parcel_type == null)
                return SP.alertX(SP.Localize("text_please_select_parcel_type"));

            let lines: { orderLineId: string, qty: number }[] = [];


            let postData: any = {
                orderId: this.shipment.order.orderId,
                shipmentId: this.shipment.shipmentId,
                width: this.width,
                length: this.length,
                height: this.height,
                weight: this.weight,
                fulfillmentLocation: this.tote.pickSettings.fulfillmentLocation,
                deliveryMethodId: this.selected_delivery_method,
                parcelType: this.selected_parcel_type,
                packagingId: this.selected_packaging?.id ?? SP.Guid.Empty,
                deliveryInstructions: this.fpo_delivery_instructions.value,
                orderNo: this.fpo_order.value,
                referenceNo: this.fpo_reference.value,
                addons: this.addons,
                parameters: this.parameters,
                isColli: this.selectedDeliveryMethod.useColliBooking,
                packageLines: lines
            }

            let total_send = 0;
            let total = 0;

            for (let l_id in this.items) {
                let item = this.items[l_id];
                if (item.max == 0) continue;
                lines.push({
                    orderLineId: l_id,
                    qty: item.quantity
                });
                total_send += item.quantity;
                total += item.max;
                if (item.quantity > item.max) return SP.alertX(SP.Localize("text_packing_to_many_items"));
            }

            if (total_send == 0) return SP.alertX(SP.Localize("sentance_no_items_packed"));

            var last = total == total_send;

            if (!last && !App_Settings.userSettings.allow_split_delivery) return SP.alertX(SP.Localize("sentance_split_delivery_not_allowed"));

            if (!last && !this.selectedDeliveryMethod.useColliBooking && !await SP.confirmX(SP.Localize("text_split_delivery"))) return;

      

            DeviceLog.log(`Printing label for order ${this.shipment.order.orderNo}`)
            var result: any = await SP.post("/api/v1/package/create?autoprint=true&a4_printer=" + App_Settings.terminalSettings.a4_printer + "&label_printer=" + App_Settings.terminalSettings.label_printer + "&etiquette_printer=" + App_Settings.terminalSettings.etiquette_printer + "&last=" + last, postData);


            if (last && (this.shipment.order.printDeliveryNote
                || (this.tote.pickSettings?.forceDeliveryNote ?? false)
                || (this.selectedDeliveryMethod?.forceDeliveryNote ?? false))) this.printDeliveryNote(true);


            //success
            if (result.status == 200) {
                SP.Sounds.Click.play();

                //Print documents
                var result: any = await SP.post("/api/v1/package/printDocuments/" + result.packageId, {
                    label_printer: App_Settings.terminalSettings.label_printer,
                    etiquette_printer: App_Settings.terminalSettings.etiquette_printer,
                    a4_printer: App_Settings.terminalSettings.a4_printer,
                    print_order_documents: last
                });

                return await this.reloadView();

            }

            //success, no print only
            if (result.status == 1002) {
                SP.Sounds.Click.play();
                await this.reloadView();
                let msg = `${result.status}: ${result.msg + (result.exception ? " - " + result.exception : "")}`;
                DeviceLog.log(msg);
                console.log("ERROR");
                return await SP.alertX(msg);
            }

            //fail
            else {
                SP.Sounds.Error.play();
                let msg = `${result.status}: ${result.msg + (result.exception ? " - " + result.exception : "")}`;
                DeviceLog.log(msg);
                return await SP.alertX(msg);
            }

        }

        async printDeliveryNote(save:boolean) {
            this.fpo_print_note_button.classList.add("btn_disabled");
            if (!App_Settings.terminalSettings.label_printer)
                return await SP.alertX(SP.Localize("sentance_please_select_printer"));

            var result = await SP.post<any>("/api/v1/shipment/printnote/" + this.shipment.shipmentId,
                {
                    label_printer: App_Settings.terminalSettings.label_printer,
                    etiquette_printer: App_Settings.terminalSettings.etiquette_printer,
                    a4_printer: App_Settings.terminalSettings.a4_printer,
                    saveShipmentTemplate: save
                }
            );
            DeviceLog.log(`Printing deliverynote for order ${this.shipment.order.orderNo} (printer:${App_Settings.terminalSettings.label_printer})`)

            if (result.status != 200) {
                let msg = `${result.status}: ${result.msg + (result.exception ? " - " + result.exception : "")}`;
                DeviceLog.log(msg);
                await SP.alertX(msg);
            }
            this.fpo_print_note_button.classList.remove("btn_disabled");
        }
    }
    RegisterApp("app_fast_pack_order", App_Fast_Pack_Order);
}